import { withDisplayName } from '@hocs/with-display-name'
import { useLocation } from '@reach/router'
import RichText from '@resolvers/rich-text'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import { Accordion } from '@ui/accordion'
import { Hyperlink } from '@ui/hyperlink'
import { kebabCase } from '@utils/utils'
import { graphql } from 'gatsby'
import React, { useEffect, useState } from 'react'

const ContentfulContentArticleAccordion: Utils.EntryFC<
  Queries.ContentfulContentArticleFragment
> = ({
  content: {
    id,
    contentArticleTitle: title,
    content,
    contentLinkText,
    contentLinkUrl,
  },
  fieldInspectorProps,
}) => {
  const accordionId = `${title ? `${kebabCase(title?.text)}-` : ''}${id}`
  const { hash } = useLocation()

  const [expanded, setExpanded] = useState<boolean | string>(false)
  const handleChange = (panel: string) => (isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false)
  }

  useEffect(() => {
    if (hash === `#${accordionId}`) {
      setExpanded(accordionId)
    }
  }, [hash, accordionId])

  return (
    <Accordion
      expanded={expanded === accordionId}
      id={accordionId}
      title={title?.text}
      onChange={handleChange(accordionId)}
    >
      {content && (
        <RichText
          {...fieldInspectorProps({
            fieldId: 'content',
          })}
          content={content}
          options={defaultRichTextFieldOptionsDeprecated}
        />
      )}
      {contentLinkText && contentLinkUrl && (
        <Hyperlink
          {...fieldInspectorProps({
            fieldId: 'contentLinkText',
          })}
          href={contentLinkUrl}
        >
          {contentLinkText}
        </Hyperlink>
      )}
    </Accordion>
  )
}

export const query = graphql`
  fragment ContentArticleAccordion on Contentful4TmD9EihHakmKMkEwKaUwQ {
    ...ContentfulEntry
    contentArticleTitle: title {
      ...ContentfulContentArticleTitle
    }
    content {
      ...ContentfulContentArticleContent
    }
    contentLinkText
    contentLinkUrl
  }
`

export default withDisplayName(
  ContentfulContentArticleAccordion,
  'ContentfulContentArticleAccordion'
)
